<app-layout>
    <section class="container">
        <app-voltar [route]="'listagem/blacklist'" />
        <div class="headerForm">
            <div class="title">
                <app-titulo>{{ title }}</app-titulo>
            </div>
            <div class="espacamento"></div>
        </div>
        <div class="forms">
            <h4 class="forms__subtitle">Informe a placa do cavalo para localizar e informar os demais dados:</h4>
            <form [formGroup]="form">
                <div class="formList">

                    <app-input type="dropdown" label="Identificador (Chave de Bloqueio)" name="NU_IDNT_CHVE"
                        formControlName="NU_IDNT_CHVE" placeholder="Selecione" [requiredInput]="true"
                        [selectData]="identificadorOptions" />

                    <app-input type="text" label="Valor do Identificador" name="TX_IDNT_VALR"
                        formControlName="TX_IDNT_VALR" [placeholder]="placeholderIdentificador" [requiredInput]="true"
                        [mask]="maskIdentificador" />

                    <app-input type="dropdown" label="Tipo de Ação a Aplicar" name="NU_TIPO_BLOQ"
                        formControlName="NU_TIPO_BLOQ" placeholder="Digite aqui" [requiredInput]="true"
                        [selectData]="situacaoOptions" />

                    <app-input type="datetime-local" label="Duração do Bloqueio" name="DT_DURC_BLOQ"
                        formControlName="DT_DURC_BLOQ" [requiredInput]="true" [somenteDataFutura]="true"/>

                    <app-input type="textarea" label="Motivo Detalhado da Ação" name="TX_DTLH_BLOQ"
                        formControlName="TX_DTLH_BLOQ" placeholder="Digite aqui" [requiredInput]="true" width="100%"
                        style="flex-grow: 1;" />



                </div>
                <app-botao *ngIf="!disabledBtn" type="cadastro" [text]="title" class="botao-cadastro"
                    (click)="postarDados()"></app-botao>
            </form>
        </div>
        <app-loader [isLoading]="isLoading"></app-loader>
    </section>
</app-layout>